import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://api.teste.csseguros.evolutiosistemas.com/',
    timeout: 60000
});

